var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#FFCD00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2947_606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6095 31.7238L28.44 26.5543C29.7771 24.819 30.5714 22.6457 30.5714 20.2857C30.5714 14.6057 25.9657 10 20.2857 10C14.6057 10 10 14.6057 10 20.2857C10 25.9657 14.6057 30.5714 20.2857 30.5714C22.6457 30.5714 24.819 29.7771 26.5543 28.44L31.7238 33.6095C31.9848 33.8705 32.3257 34 32.6667 34C33.0076 34 33.3486 33.8705 33.6095 33.6095C34.1295 33.0895 34.1295 32.2438 33.6095 31.7238ZM12.6667 20.2857C12.6667 16.0838 16.0838 12.6667 20.2857 12.6667C24.4876 12.6667 27.9048 16.0838 27.9048 20.2857C27.9048 24.4876 24.4876 27.9048 20.2857 27.9048C16.0838 27.9048 12.6667 24.4876 12.6667 20.2857Z",
    fill: "#011A33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2947_606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchButton);
export default __webpack_public_path__ + "static/media/Search_button.61c57dcd091d3427311d49d2c461c93f.svg";
export { ForwardRef as ReactComponent };